import classNames from 'classnames';
import React from 'react';
import EfImg from '../ef-img';
import './index.scss';

export interface EfProductCompareCSpecProps {
    /**
     * 标题
     */
    title?: React.ReactNode;
    /**
     * 描述
     */
    desc?: React.ReactNode;
}
export interface EfProductCompareCItemProps {
    /**
     * 所有分辨率展示的资源链接
     */
    pc?: string;
    /**
     * 分辨率小于等于1024px展示的资源链接
     */
    h5?: string;
    /**
     * 标题
     */
    title?: React.ReactNode;
    /**
     * 描述
     */
    desc?: React.ReactNode;
    /**
     * 参数
     */
    specList?: EfProductCompareCSpecProps[];
}
interface EfProductCompareCProps {
    /**
     * 主题样式
     */
    theme?: 'default' | 'bg1' | 'transparent';
    /**
     * 样式名
     */
    className?: string;
    /**
     * 列表(每个item为一列)
     */
    items: EfProductCompareCItemProps[];
    /**
     * 第一列颜色是否是默认颜色
     */
    isUseFirstGray?: boolean;
}

// 参数转换
const getListHandle = (items: EfProductCompareCItemProps[]) => {
    const length = items.length;
    const resultC: any = [];
    const specListAll = [];
    let specListLength = 0;

    const itemB1 = []; // 保存header
    for (let i = 0; i < length; i++) {
        const itemA1 = items[i]; // 来源处
        itemB1.push({
            isHead: true,
            pc: itemA1.pc,
            h5: itemA1.h5,
            title: itemA1.title,
            desc: itemA1.desc,
        });

        const specList = itemA1.specList || [];
        specListLength = specList.length;
        specListAll.push(...specList);
    }
    resultC.push(itemB1); //保存header
    for (let m = 0; m < specListLength; m++) {
        const itemB2 = []; // 保存值
        for (let n = 0; n < length; n++) {
            const itemA2 = specListAll[m + n * specListLength];
            itemB2.push({
                title: itemA2.title,
                desc: itemA2.desc,
            });
        }
        resultC.push(itemB2); //保存第i列的数据
    }

    return resultC;
};

/**
 * 维护:谢保林
 *
 * 产品对比
 *
 * 每个item为一列
 *
 * 使用 div 实现 table 布局,会自动对齐
 */
const EfProductCompareC: React.FC<EfProductCompareCProps> = ({ isUseFirstGray = true, theme, items = [], className }) => {
    const prefixCls = `ef-product-compare-c`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
        [`${prefixCls}-${theme}`]: theme,
        [`${prefixCls}-firstGray`]: isUseFirstGray,
    });

    console.log({ theme });
    console.log({ classes });
    const items2 = getListHandle(items);

    return (
        <div className={classes}>
            <div className={`${prefixCls}-table`}>
                {items2.map((item1: any, index1: number) => {
                    return (
                        <div className={`${prefixCls}-tr ${prefixCls}-tr-${index1 + 1}${index1 === 0 ? ` ${prefixCls}-tr-head` : ''}`} key={index1}>
                            {item1?.map((item2: any, index2: number) => {
                                return (
                                    <div
                                        className={`${prefixCls}-td${` ${prefixCls}-td-${index2 + 1}`}${item2.isHead ? ` ${prefixCls}-td-head` : ''}`}
                                        key={index2}
                                    >
                                        <div className={`${prefixCls}-td-in`}>
                                            {item2.pc && (
                                                <div className={`${prefixCls}-item-img`}>
                                                    <EfImg pc={item2.pc} />
                                                </div>
                                            )}
                                            <div className={`${prefixCls}-item-info`}>
                                                <div className={`${prefixCls}-item-title`}>{item2.title}</div>
                                                <div className={`${prefixCls}-item-desc`}>{item2.desc}</div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default EfProductCompareC;
